import api from '../../api'

const recurrenceAPI = api.create('recurrence')

const get = ({ contractId }) => {
  return recurrenceAPI.get(`contracts/${contractId}/contract_emails`)
}

const create = ({ contractId, ...data }) => {
  return recurrenceAPI.post(`contracts/${contractId}/contract_emails`, data)
}

const destroy = ({ contractId, contractEmailId }) => {
  return recurrenceAPI.delete(
    `contracts/${contractId}/contract_emails/${contractEmailId}`,
  )
}

export default {
  get,
  create,
  destroy,
}
